import { dataTrendPages } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendPages = /*#__PURE__*/createIcon(dataTrendPages)
export default IconTrendPages
